export default "/img/PY.4b5da8ede915cfa828aa8be67e06d668.png";